import { render, staticRenderFns } from "./SectionSlide.vue?vue&type=template&id=dba5a572&scoped=true&"
import script from "./SectionSlide.vue?vue&type=script&lang=js&"
export * from "./SectionSlide.vue?vue&type=script&lang=js&"
import style0 from "./SectionSlide.vue?vue&type=style&index=0&id=dba5a572&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dba5a572",
  null
  
)

export default component.exports